import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extended-menu',
  templateUrl: './extended-menu.component.html',
  styleUrls: ['./extended-menu.component.css']
})
export class ExtendedMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
